import { apiWrapper } from '../../config/api-wrapper';
import { Translation, UpdateTranslation } from './translations-model';

class TranslationService {
  public listTranslations(locales?: string[] | string, translateFrom?: string): Promise<Translation[]> {
    const params = new URLSearchParams();
    if (Array.isArray(locales)) {
      locales.forEach(locale => params.append('locale', locale));
    } else if (locales) {
      params.append('locale', locales);
    }
    if (translateFrom) {
      params.append('translateFrom', translateFrom);
    }
    const queryString = params.toString();
    const url = '/translation' + (queryString ? `?${queryString}` : '');
    return apiWrapper.adminApi.get(url).then(res => res.data);
  }
  public listTranslationsProperties(): Promise<string[]> {
    return apiWrapper.api.get('/api/translation/properties').then(res => res.data);
  }
  public addTranslation(translation: Translation): Promise<void> {
    return apiWrapper.adminApi.post('/translation', translation);
  }
  public updateTranslation(translationId: number, translation: UpdateTranslation): Promise<void> {
    return apiWrapper.adminApi.put(`/translation/${translationId}`, translation);
  }
  public removeTranslation(translationId: number): Promise<void> {
    return apiWrapper.adminApi.delete(`/translation/${translationId}`);
  }
}

const translationService = new TranslationService();
export default translationService;
